import React from 'react';
import Hero from './components/Hero';
import Trust from './components/Trust';
import HowItWorks from './components/HowItWorks';
import FAQ from './components/FAQ';
import CTAButton from './components/CTAButton';
import SecondaryButton from './components/SecondaryButton';
import WhatsAppWidget from './components/WhatsAppWidget';

function App() {
  return (
    <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-emerald-200 selection:text-emerald-900 overflow-x-hidden">
      {/* Slim Nav */}
      <nav className="p-4 md:p-6 flex justify-between items-center max-w-7xl mx-auto">
        <div className="font-black text-2xl tracking-tighter text-emerald-600">
          STOCK<span className="text-gray-900">BONUS</span>
        </div>
        <div className="flex items-center gap-4">
          <a href="https://link.ajedolabomi.com/whatsapp-help" target="_blank" className="text-sm font-bold text-gray-500 hover:text-emerald-600 hidden md:block">
            Need help?
          </a>
          <CTAButton className="!py-2 !px-6 !text-sm" text="Claim Now" />
        </div>
      </nav>

      <main>
        <Hero />
        <Trust />
        <HowItWorks />
        <FAQ />
        
        {/* Convergent Section */}
        <section className="py-24 bg-emerald-600 text-center px-4">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-5xl font-black text-white mb-6">
              Don't leave €100 on the table.
            </h2>
            <p className="text-emerald-50 text-lg mb-10 opacity-90">
              I'm ready to guide you step-by-step through the verification. 
              Most users finish in under 5 minutes.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <CTAButton className="bg-white !text-emerald-600 hover:bg-gray-100 w-full sm:w-auto" text="Start Now" />
              <a 
                href="https://link.ajedolabomi.com/whatsapp-help" 
                target="_blank"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 text-white font-bold py-4 px-8 rounded-full border-2 border-white/30 hover:bg-white/10 transition-all text-lg"
              >
                Guide Me on WhatsApp
              </a>
            </div>
          </div>
        </section>
      </main>

      <footer className="py-12 bg-gray-50 text-center border-t border-gray-100">
        <div className="max-w-4xl mx-auto px-4">
          <p className="text-xs text-gray-400 font-medium uppercase tracking-widest mb-4">
            Regulated Investment Platform • 10M+ Users
          </p>
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} Referral Offer. All rights reserved. <br/>
            Capital at risk. Promotion terms apply.
          </p>
        </div>
      </footer>

      <WhatsAppWidget />
    </div>
  );
}

export default App;